/**
 * Tipos del dominio Empresa, alineados con el schema SQL en
 * supabase/migrations/20260415000000_initial_schema.sql
 */

export type EstadoEmpresa = 'activa' | 'inactiva' | 'suspendida';

export type CondicionIva =
  | 'responsable_inscripto'
  | 'monotributista'
  | 'exento'
  | 'consumidor_final'
  | 'no_responsable';

/** Empresa tal como viene de la BD */
export interface Empresa {
  id: string;
  cuit: string;
  razon_social: string;
  domicilio: string | null;
  condicion_iva: CondicionIva | null;
  telefono: string | null;
  email: string | null;
  fecha_alta: string | null; // ISO date
  fecha_inicio_actividades: string | null;
  convenio_2_porc: boolean;
  estado: EstadoEmpresa;
  observaciones: string | null;
  delegacion_id: string | null;
  created_at: string;
  updated_at: string;
}

/** Payload para crear empresa (sin campos auto-generados) */
export type EmpresaCreatePayload = Omit<Empresa, 'id' | 'created_at' | 'updated_at'>;

/** Payload para editar — todos los campos opcionales excepto id */
export type EmpresaUpdatePayload = Partial<EmpresaCreatePayload>;

/** Filtros de busqueda */
export interface EmpresasFilter {
  search?: string;
  estado?: EstadoEmpresa | 'todas';
  page?: number;
  pageSize?: number;
}

/** Resultado paginado */
export interface EmpresasResult {
  data: Empresa[];
  count: number;
  page: number;
  pageSize: number;
}

// ===== Helpers de presentacion =====

export const ESTADO_EMPRESA_LABELS: Record<EstadoEmpresa, string> = {
  activa: 'Activa',
  inactiva: 'Inactiva',
  suspendida: 'Suspendida',
};

export const CONDICION_IVA_LABELS: Record<CondicionIva, string> = {
  responsable_inscripto: 'Responsable Inscripto',
  monotributista: 'Monotributista',
  exento: 'Exento',
  consumidor_final: 'Consumidor Final',
  no_responsable: 'No Responsable',
};

export const ESTADO_EMPRESA_COLORS: Record<EstadoEmpresa, 'success' | 'default' | 'error'> = {
  activa: 'success',
  inactiva: 'default',
  suspendida: 'error',
};

export const CONDICION_IVA_OPTIONS = Object.entries(CONDICION_IVA_LABELS).map(
  ([value, label]) => ({ value: value as CondicionIva, label })
);

export const ESTADO_EMPRESA_OPTIONS = Object.entries(ESTADO_EMPRESA_LABELS).map(
  ([value, label]) => ({ value: value as EstadoEmpresa, label })
);
